<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script lang="ts" setup>
  import { onMounted } from 'vue'
  import { AUTHZ_INTERCEPTOR_KEY } from './components/Authentication/services/authorization-interceptor'
  import { injectTyped } from './inject'
  import { STATUS_CODE_INTERCEPTOR_KEY } from './components/Authentication/services/status-code-interceptor'
  import { LOADING_INTERCEPTOR_KEY } from './components/Authentication/services/loading-interceptor'

  onMounted(() => {
    injectTyped(AUTHZ_INTERCEPTOR_KEY).enable()
    injectTyped(STATUS_CODE_INTERCEPTOR_KEY).enable()
    injectTyped(LOADING_INTERCEPTOR_KEY).enable()
  })
</script>
